var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "calendar_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.167 2.5h-.834v-.833A.836.836 0 0 0 15.5.833a.836.836 0 0 0-.833.834V2.5H6.333v-.833A.836.836 0 0 0 5.5.833a.836.836 0 0 0-.833.834V2.5h-.834c-.916 0-1.666.75-1.666 1.667V17.5c0 .917.75 1.667 1.666 1.667h13.334c.916 0 1.666-.75 1.666-1.667V4.167c0-.917-.75-1.667-1.666-1.667Zm-.834 15H4.667a.836.836 0 0 1-.834-.833v-10h13.334v10a.836.836 0 0 1-.834.833Z",
    fill: "currentColor"
  })));
};
export { SvgCalendar as ReactComponent };